import axios from 'axios';

import type {
  GetProfileHeroImageResT,
  PostProfileHeroImageBodyT,
  PostProfileHeroImageResT,
} from 'server/controllers';

import {
  E_PROFILE_HERO_IMAGE,
  type ImageAssetT,
  P_API_ARTIST,
  getConfig,
  getServerServices,
} from 'utils';

const ss = getServerServices();

export async function getProfileHeroImage(
  artistId: string,
): Promise<ImageAssetT | null> {
  if (ss) return ss.getProfileHeroImage(artistId);

  const res = await axios<GetProfileHeroImageResT>(
    `${P_API_ARTIST}/${artistId}${E_PROFILE_HERO_IMAGE}`,
  );

  return res.data;
}

export async function setProfileHeroImage(
  artistId: string,
  assetId: string,
): Promise<ImageAssetT> {
  if (ss) throw Error('Client-side only');

  const config = getConfig(true);

  const res = await axios.post<PostProfileHeroImageResT>(
    `${P_API_ARTIST}/${artistId}${E_PROFILE_HERO_IMAGE}`,
    {
      _csrf: config.CSRF,
      assetId,
    } satisfies PostProfileHeroImageBodyT,
  );

  return res.data;
}

